import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || 'https://server.pigmo.com',
})

instance.interceptors.request.use((config) => {
  const accessToken = window.localStorage.getItem('access_token')

  if (accessToken !== null) {
    config.headers['Authorization'] = accessToken
  }

  return config
})

export const api = instance
